import { FILE_URL } from '../config';
import Upload from '../../upload';
import GET from '../../get';

/**
 * 上传文件
 * @param params
 */
export function file_upload_api(params: FormData) {
  return Upload(`${FILE_URL}/upload`, params);
}
/**
 * 上传图片
 * @param params
 */
export function file_uploadImage_api(params: FormData) {
  return Upload(`${FILE_URL}/uploadImage`, params);
}
/**
 * 获取oss上传参数
 * @param params
 */
export function oss_file_getPostPolicy_api(type: string) {
  return GET(`${FILE_URL}/getPostPolicy`, { type });
}
/**
 * 上传minio
 * @param params
 */
export function minio_upload_api(url: string, params: FormData) {
  return Upload(url, params);
}
